// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161735/js/" + chunkId + "." + {"44":"7962d1c5","225":"9098b255","481":"6ad947cd","486":"4fc341c1","770":"39d00c25"}[chunkId] + ".0.13144857779375685.chunk.js";
};